import React from 'react';
import EmailPassword from './../../components/EmailPassword';

const Recovery = props => {
  window.scrollTo(0, 0);
  return <EmailPassword />
}

export default Recovery;